<template>
  <div class="hero-benefits" :class="{ container: $store.state.layout === 'mobile' }">
    <p v-for="(b, i) in benefits" :key="i" class="benefit">
      <IconCheckBenefits />
      {{ b }}
    </p>
  </div>
</template>

<script>
import IconCheckBenefits from '../../assets/svg/icon-check-light-blue-bold.svg?vue-component';

export default {
  components: { IconCheckBenefits },
  props: {
    benefits: { type: Array, default: () => ([]), required: true },
  },
};
</script>

<style lang="scss" scoped>
.hero-benefits {
  margin: var(--spacing-28) 0;

  .benefit {
    position: relative;
    padding-left: var(--spacing-30);
    line-height: 1.5;
    font-weight: 400;
    margin: 0;

    + .benefit {
      margin-top: var(--spacing-12);
    }

    svg {
      position: absolute;
      left: 0;
      top: 4px;

      [fill] {
        fill: var(--extreme-blue);
      }

      [stroke] {
        stroke: var(--extreme-blue);
      }
    }
  }

  @include bp($bp-mobile) {
    display: block;
    margin: 0 0 var(--spacing-24) 0;
    padding: 0;
    font-size: 16px;
    font-weight: 400;
    color: var(--main-light);

    .subtitle {
      display: flex;
      flex-direction: row;
      line-height: 150%;
      margin-bottom: var(--spacing-16);

      &:last-of-type {
        margin-bottom: 0;
      }

      svg {
        margin-top: 4px;
        flex-shrink: 0;
      }
    }
  }
}

.fa .hero-benefits .benefit svg {
  [fill] {
    fill: var(--accent-light-3);
  }

  [stroke] {
    stroke: var(--accent-light-3);
  }
}
</style>
